/**
 * @packageDocumentation
 * @module StockChartModule
 */
import { StockChartOptions } from './stock-chart-model';

/**
 * Range Selector config buttons taken from APWRIMS
 */
export const rangeSelectorBtnAllOptions = [{
  type: 'day',
  count: 5,
  text: '5d',
  timeRangeInMillis: 432000000,
}, {
  type: 'week',
  count: 1,
  text: '1w',
  timeRangeInMillis: 604800000,
}, {
  type: 'day',
  count: 15,
  text: '15d',
  timeRangeInMillis: 1296000000,
}, {
  type: 'month',
  count: 1,
  text: '1m',
  timeRangeInMillis: 2592000000,
}, {
  type: 'month',
  count: 3,
  text: '3m',
  timeRangeInMillis: 7776000000,
}, {
  type: 'month',
  count: 6,
  text: '6m',
  timeRangeInMillis: 15552000000,
}, {
  type: 'year',
  count: 1,
  text: '1y',
  timeRangeInMillis: 31536000000,
}, {
  type: 'mytd',
  text: 'MYTD'
}, {
  type: 'ytd',
  text: 'YTD',
  // timeRangeInMillis:0,
}, {
  type: 'all',
  text: 'All',
}];

/**
 * Themes for highcharts
 */
export const themes = {
  light: {
    colors: ['blue', 'green', '#8bbc21', '#F8FBFE', '#1aadce', '#492970',
      '#f28f43', '#77a1e5', '#F8FBFE', '#a6c96a'
    ],
    chart: {
      backgroundColor: '#fff',
      borderWidth: 0,
      plotBackgroundColor: '#fff',
      plotShadow: false,
      plotBorderWidth: 0
    },
    title: {
      style: {
        color: '#274b6d', // #3E576F',
        fontSize: '16px'
      }
    },
    subtitle: {
      style: {
        color: '#4d759e'
      }
    },
    xAxis: {
      gridLineWidth: 0,
      lineColor: '#C0D0E0',
      tickColor: '#C0D0E0',
      labels: {
        style: {
          color: '#666',
          cursor: 'default',
          fontSize: '11px',
          lineHeight: '14px'
        }
      },
      title: {
        style: {
          color: '#4d759e',
          fontWeight: 'bold'
        }
      }
    },
    yAxis: {
      gridLineColor: '#f2f2f2',
      minorTickInterval: null,
      lineColor: '#C0D0E0',
      lineWidth: 1,
      gridLineWidth: 0,
      tickWidth: 1,
      tickColor: '#C0D0E0',
      labels: {
        style: {
          color: '#666',
          cursor: 'default',
          fontSize: '11px',
          lineHeight: '14px'
        }
      },
      title: {
        style: {
          color: '#4d759e',
          fontWeight: 'bold'
        }
      }
    },
    tooltip: {
      backgroundColor: '#f7f7f7',
      style: {
        color: '#0f0f0f'
      }
    },
    legend: {
      backgroundColor: '#f7f7f7',
      itemStyle: {
        color: '#274b6d',
        fontSize: '12px'
      },
      itemHoverStyle: {
        color: '#000'
      },
      itemHiddenStyle: {
        color: '#CCC'
      }
    },
    plotOptions: {
      series: {
        dataLabels: {
          color: '#B0B0B3'
        },
        marker: {
          lineColor: '#000'
        },
        fillColor: {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1
          },
          stops: [
            [0, 'black'],
            [1, 'red']
          ]
        }

      },
      boxplot: {
        fillColor: '#505053'
      },
      candlestick: {
        lineColor: '#333'
      },
      errorbar: {
        color: 'white'
      }
    },
    labels: {
      style: {
        color: '#3E576F'
      }
    },
    navigation: {
      buttonOptions: {
        theme: {
          stroke: '#CCCCCC'
        }
      }
    },
    rangeSelector: {
      buttonTheme: {
        fill: '#f7f7f7',
        stroke: '#000000',
        style: {
          color: '#505053'
        },
        states: {
          hover: {
            fill: '#e6e6e6',
            stroke: '#000000',
            style: {
              color: 'black'
            }
          },
          select: {
            fill: '#e6ebf5',
            stroke: '#000000',
            style: {
              color: '#505053'
            }
          }
        }
      },
      inputBoxBorderColor: '#505053',
      inputStyle: {
        backgroundColor: '#fff',
        color: '#505053'
      },
      labelStyle: {
        color: '#505053'
      }
    },
    exporting: {
      buttons: {
        contextButton: {
          symbolStroke: '#505053',
          theme: {
            fill: '#fff'
          }
        }
      }
    },
    navigator: {
      series: {
        type: 'areaspline',
        marker: {
          enabled: false
        },
        pointRange: 0,
        threshold: null,
        color: '#7798BF'
      },
      handles: {
        backgroundColor: '#f2f2f2',
        borderColor: '#AAA'
      },
      outlineColor: '#CCC',
      maskFill: 'rgba(102,133,194,0.3)',
      maskInside: true,
      color: 'SteelBlue',
      lineColor: '#358AA3',
      xAxis: {
        gridLineColor: '#e6e6e6'
      }
    },
    scrollbar: {
      barBackgroundColor: '#cccccc',
      barBorderColor: '#cccccc',
      buttonArrowColor: '#333333',
      buttonBackgroundColor: '#e6e6e6',
      buttonBorderColor: '#cccccc',
      rifleColor: '#333333',
      trackBackgroundColor: '#f2f2f2',
      trackBorderColor: 'white'
    }
  },
  dark: {
    colors: ['red', 'orange', '#255498', '#93bced', '#aaeeee', '#ff0066',
      '#eeaaee', '#55BF3B', '#DF5353', '#7798BF', '#aaeeee'
    ],
    chart: {
      backgroundColor: '#000000',
      style: {
        // fontFamily: '\'Unica One\', sans-serif'
      },
      plotBorderColor: '#606063',
      plotBackgroundColor: '#00000',
    },
    title: {
      style: {
        color: '#E0E0E3',
        textTransform: 'uppercase',
        fontSize: '20px'
      }
    },
    subtitle: {
      style: {
        color: '#E0E0E3',
        textTransform: 'uppercase'
      }
    },
    xAxis: {
      gridLineColor: '',
      gridLineWidth: 0,
      lineColor: '#707073',
      minorGridLineColor: '#505053',
      tickColor: '#707073',
      labels: {
        style: {
          color: '#E0E0E3'
        }
      },
      title: {
        style: {
          color: '#A0A0A3'

        }
      }
    },
    yAxis: {
      gridLineColor: '#4D4D4D',
      gridLineWidth: 0,
      minorGridLineWidth: 0,
      lineWidth: 0,
      minorTickInterval: null,
      labels: {
        style: {
          color: '#E0E0E3'
        }
      },
      lineColor: '#707073',
      minorGridLineColor: '#505053',
      tickColor: '#707073',
      tickWidth: 1,
      title: {
        style: {
          color: '#A0A0A3'
        }
      }
    },
    tooltip: {
      backgroundColor: 'rgba(0, 0, 0, 0.85)',
      style: {
        color: '#F0F0F0'
      }
    },
    plotOptions: {
      series: {
        dataLabels: {
          color: '#B0B0B3'
        },
        marker: {
          lineColor: '#333'
        }
      },
      boxplot: {
        fillColor: '#505053'
      },
      candlestick: {
        lineColor: 'white'
      },
      errorbar: {
        color: 'white'
      }
    },
    legend: {
      itemStyle: {
        color: '#E0E0E3'
      },
      itemHoverStyle: {
        color: '#FFF'
      },
      itemHiddenStyle: {
        color: '#606063'
      }
    },
    credits: {
      style: {
        color: '#666'
      }
    },
    labels: {
      style: {
        color: '#707073'
      }
    },

    drilldown: {
      activeAxisLabelStyle: {
        color: '#F0F0F3'
      },
      activeDataLabelStyle: {
        color: '#F0F0F3'
      }
    },

    navigation: {
      buttonOptions: {
        symbolStroke: '#DDDDDD',
        theme: {
          fill: '#505053'
        }
      }
    },

    // scroll charts
    rangeSelector: {
      buttonTheme: {
        fill: '#505053',
        stroke: '#000000',
        style: {
          color: '#CCC'
        },
        states: {
          hover: {
            fill: '#707073',
            stroke: '#000000',
            style: {
              color: 'white'
            }
          },
          select: {
            fill: '#000003',
            stroke: '#000000',
            style: {
              color: 'white'
            }
          }
        }
      },
      inputBoxBorderColor: '#505053',
      inputStyle: {
        backgroundColor: '#333',
        color: 'silver'
      },
      labelStyle: {
        color: 'silver'
      }
    },
    navigator: {
      series: {
        type: 'areaspline',
        marker: {
          enabled: false
        },
        pointRange: 0,
        threshold: null,
        color: 'red'
      },
      handles: {
        backgroundColor: '#f2f2f2',
        borderColor: '#AAA'
      },
      outlineColor: '#CCC',
      maskFill: 'rgba(102,133,194,0.3)',
      maskInside: true,
      color: 'SteelBlue',
      lineColor: '#358AA3',
      xAxis: {
        gridLineColor: '#e6e6e6'
      },
    },

    scrollbar: {
      barBackgroundColor: '#808083',
      barBorderColor: '#808083',
      buttonArrowColor: '#CCC',
      buttonBackgroundColor: '#606063',
      buttonBorderColor: '#606063',
      rifleColor: '#FFF',
      trackBackgroundColor: '#404043',
      trackBorderColor: '#404043'
    },

    // special colors for some of the
    legendBackgroundColor: 'rgba(0, 0, 0, 0.5)',
    background2: '#505053',
    dataLabelsColor: '#B0B0B3',
    textColor: '#C0C0C0',
    contrastTextColor: '#F0F0F3',
    maskColor: 'rgba(255,255,255,0.3)',

    exporting: {
      buttons: {
        contextButton: {
          symbolStroke: '#505053',
          theme: {
            fill: '#fff'
          }
        }
      }
    }
  },
  sandSignika: {
    colors: ['#f45b5b', '#8085e9', '#8d4654', '#7798BF', '#aaeeee',
      '#ff0066', '#eeaaee', '#55BF3B', '#DF5353', '#7798BF', '#aaeeee'
    ],
    chart: {
      backgroundColor: '#fff',
      plotBackgroundColor: '#fff',
      style: {
        // fontFamily: 'Signika, serif'
      }
    },
    title: {
      style: {
        color: 'black',
        fontSize: '16px',
        fontWeight: 'bold'
      }
    },
    subtitle: {
      style: {
        color: 'black'
      }
    },
    tooltip: {
      borderWidth: 0
    },
    legend: {
      itemStyle: {
        fontWeight: 'bold',
        fontSize: '13px'
      }
    },
    xAxis: {
      gridLineWidth: 0,
      labels: {
        style: {
          color: '#6e6e70'
        }
      }
    },
    yAxis: {
      gridLineColor: '#f2f2f2',
      minorTickInterval: null,
      labels: {
        style: {
          color: '#6e6e70'
        }
      }
    },
    plotOptions: {
      series: {
        shadow: true
      },
      candlestick: {
        lineColor: '#404048'
      },
      map: {
        shadow: false
      }
    },

    // Highstock specific
    navigator: {
      xAxis: {
        gridLineColor: '#D0D0D8'
      }
    },
    rangeSelector: {
      buttonTheme: {
        fill: 'white',
        stroke: '#C0C0C8',
        'stroke-width': 1,
        states: {
          select: {
            fill: '#D0D0D8'
          }
        }
      },
      inputBoxBorderColor: '#505053',
      inputStyle: {
        backgroundColor: '#fff',
        color: '#333333'
      },
      labelStyle: {
        color: '#333333'
      }
    },
    scrollbar: {
      barBackgroundColor: '#808083',
      barBorderColor: '#808083',
      buttonArrowColor: '#CCC',
      buttonBackgroundColor: '#606063',
      buttonBorderColor: '#606063',
      rifleColor: '#FFF',
      trackBackgroundColor: '#404043',
      trackBorderColor: '#C0C0C8'
    },

    // General
    background2: '#E0E0E8',
    exporting: {
      buttons: {
        contextButton: {
          symbolStroke: '#505053',
          theme: {
            fill: '#fff'
          }
        }
      }
    }
  },
  gridLight: {
    colors: ['#7cb5ec', '#f7a35c', '#90ee7e', '#7798BF', '#aaeeee', '#ff0066',
      '#eeaaee', '#55BF3B', '#DF5353', '#7798BF', '#aaeeee'
    ],
    chart: {
      backgroundColor: '#fff',
      plotBackgroundColor: '#fff',
      style: {
        // fontFamily: 'Dosis, sans-serif'
      }
    },
    title: {
      style: {
        color: 'black',
        fontSize: '16px',
        fontWeight: 'bold',
        textTransform: 'uppercase'
      }
    },
    tooltip: {
      borderWidth: 0,
      backgroundColor: '#505053',
      shadow: false,
      style: {
        color: '#F0F0F0'
      }
    },
    legend: {
      itemStyle: {
        fontWeight: 'bold',
        fontSize: '13px'
      }
    },
    xAxis: {
      gridLineColor: '#f2f2f2',
      gridLineWidth: 0.8,
      labels: {
        style: {
          fontSize: '12px'
        }
      }
    },
    yAxis: {
      gridLineColor: '#f2f2f2',
      minorTickInterval: null,
      title: {
        style: {
          textTransform: 'uppercase'
        }
      },
      labels: {
        style: {
          fontSize: '12px'
        }
      }
    },
    plotOptions: {
      candlestick: {
        lineColor: '#404048'
      }
    },


    // General
    background2: '#F0F0EA',
    exporting: {
      buttons: {
        contextButton: {
          symbolStroke: '#505053',
          theme: {
            fill: '#fff'
          }
        }
      }
    }

  }
};

/**
 * default chart options
 * Interface:: StockChartOptions
 */
export const defaultChartOptions: StockChartOptions = {
  indicators : true,
  dateHandler: true,
  rangeSelector: true,
  secondaryChart: true,
  navigator: true,
  scrollbar: true,
  labels: true,
  connectNulls: false,
  hideDataGaps: false,
  xAxis: {
    labelFormats: {
      common: '%d-%b<br>%Y',
      dateTimeLabelFormats: {
        millisecond: '%d-%b<br>%Y',
        second: '%d-%b<br>%Y',
        minute: '%d-%b<br>%Y',
        hour: '%d-%b<br>%Y',
        day: '%d-%b<br>%Y',
        week: '%d-%b<br>%Y',
        month: '%d-%b<br>%Y',
        year: '%d-%b<br>%Y'
    },
    }
  },
  yAxis: {
    labelsAlignment: 'right',
    unitAsTitle: true,
    unitsBesideLabel: true,
    labelsFormatter: {
      functionName: 'yAxisFormatter'
    } // stock service function
  }
};
